module.exports = __webpack_public_path__ + "img/education6.7a24cb82.png";